import { Grid, Button, TextField, FormLabel, IconButton, TabPanels, TabPanel  } from "@deere/fuel-react";
import { ReactComponent as DeleteIcon } from "@deere/ux.brand-foundations/icons/delete.svg";

const SelectionsTab = ({ setError, setPayloadData, payloadData, selectedSec, que }) => {
  const optChangeHandler = (e, queCode, selCode) => {
    setError({ show: false, message: "" });
    setPayloadData((prevState) => {
      const sectionIndex = prevState.sections.findIndex((section) => section.code === selectedSec);
      const newSections = [...prevState.sections];
      const newQuestions = [...newSections[sectionIndex].questions];
      const questionIndex = newQuestions.findIndex((que) => que.code === queCode);
      const newSelections = [...newQuestions[questionIndex].selections];
      const selectionIndex = newSelections.findIndex((sel) => sel.code === selCode);
      newSelections[selectionIndex].text = e.target.value;
      newQuestions[questionIndex] = { ...newQuestions[questionIndex], selections: newSelections };
      newSections[sectionIndex] = { ...newSections[sectionIndex], questions: newQuestions };
      return { ...prevState, sections: newSections };
    });
  };

  const optDeleteHandler = (que, sel) => {
    setPayloadData((prevState) => {
      const sectionIndex = prevState.sections.findIndex((section) => section.code === selectedSec);
      const newSections = [...prevState.sections];
      const newQuestions = [...newSections[sectionIndex].questions];
      const questionIndex = newQuestions.findIndex((nq) => nq.code === que.code);
      const newSelections = [...newQuestions[questionIndex].selections];
      const index = newSelections.findIndex((ns) => ns.code === sel.code);
      if (index > -1) newSelections.splice(index, 1);
      newSelections.forEach((ns) => {
        if (ns.showOrder > sel.showOrder) {
          const newCount = ns.showOrder - 1;
          ns.showOrder = newCount;
          ns.code = ns.code.split("_")[0] + "_" + ns.code.split("_")[1] + "_" + ns.code.split("_")[2] + "_S" + newCount;
          ns.value = newCount.toString();
        }
      });
      newQuestions[questionIndex] = { ...newQuestions[questionIndex], selections: newSelections };
      newSections[sectionIndex] = { ...newSections[sectionIndex], questions: newQuestions };
      return { ...prevState, sections: newSections };
    });
  };

  const addOptHandler = (queCode) => {
    setError({ show: false, message: "" });
    let objNewOption = {
      text: "",
      active: true,
      value: "",
      showOrder: 0,
      code: queCode + "_S",
      translations:[]
    };
    setPayloadData((prevState) => {
      const sectionIndex = prevState.sections.findIndex((section) => section.code === selectedSec);
      const newSections = [...prevState.sections];
      const newQuestions = [...newSections[sectionIndex].questions];
      const questionIndex = newQuestions.findIndex((que) => que.code === queCode);
      const selectionCount = newQuestions[questionIndex].selections.length + 1;
      objNewOption.showOrder = selectionCount;
      objNewOption.code = objNewOption.code + selectionCount;
      objNewOption.value = selectionCount.toString();
      const newSelections = [...newQuestions[questionIndex].selections, objNewOption];
      newQuestions[questionIndex] = { ...newQuestions[questionIndex], selections: newSelections };
      newSections[sectionIndex] = { ...newSections[sectionIndex], questions: newQuestions };
      return { ...prevState, sections: newSections };
    });
  };

  return (
    <>
      <Grid container mt={4} spacing={4} mb={4}>
        {que.selections.length > 0 && (
          <>
            <Grid item xs={9}>
              <FormLabel sx={{ fontSize: "medium" }}>Text</FormLabel>
            </Grid>
            <Grid item xs={3} textAlign="center">
              <FormLabel sx={{ fontSize: "medium" }}>Delete</FormLabel>
            </Grid>
          </>
        )}
        {que.selections
          .sort((a, b) => (a.showOrder > b.showOrder ? 1 : -1))
          .map((sel) => {
            return (
              <Grid container key={sel.code} item spacing={2}>
                <Grid item xs={9}>
                  <TextField required placeholder="Please enter the selection text here..." name="selectionText" onChange={(e) => optChangeHandler(e, que.code, sel.code)} value={sel.text} />
                </Grid>
                <Grid item xs={3} textAlign="center" alignContent="center">
                  <IconButton onClick={() => optDeleteHandler(que, sel)}>
                    <DeleteIcon />
                  </IconButton>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
        <Button variant="primary" onClick={() => addOptHandler(que.code)}>
          Add Option
        </Button>
    </>
  );
};

export default SelectionsTab;
